import * as Icons from "lucide-react";
import { Section } from "@/components/ui/Section";
import { Card } from "@/components/ui/Card";
import { Reveal } from "@/components/common/Reveal";
import { FEATURES } from "@/utils/constants";

export const WhyDeuces = () => (
  <Section id="why" testId="why-section" bg="ink">
    <Reveal>
      <p className="text-weld-glow font-semibold tracking-[0.25em] uppercase text-sm mb-3">Why Deuce's</p>
      <h2 className="font-display text-5xl md:text-6xl text-white">Built On Trust</h2>
    </Reveal>

    <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
      {FEATURES.map((f, i) => {
        const Icon = Icons[f.icon] || Icons.BadgeCheck;
        return (
          <Reveal key={f.title} delay={(i % 4) * 0.06}>
            <Card data-testid={`feature-card-${i}`} className="p-7 h-full group">
              <div className="w-12 h-12 rounded-lg bg-weld/10 border border-weld/30 flex items-center justify-center mb-5 transition-transform group-hover:scale-110">
                <Icon className="text-weld-glow" size={24} />
              </div>
              <h3 className="text-xl font-bold text-white mb-2">{f.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{f.text}</p>
            </Card>
          </Reveal>
        );
      })}
    </div>
  </Section>
);
